import { render, staticRenderFns } from "./OpenInNew.vue?vue&type=template&id=7656380f&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OpenInNew.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/OpenInNew.vue
// module id = 2421
// module chunks = 1